<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>钻头管理</el-breadcrumb-item>
      <el-breadcrumb-item>钻头列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="form-horizontal">
      <div class="panel">
        <el-page-header
          @back="$router.go(-1)"
          :content="model.id ? '编辑钻头' : '添加钻头'"
        >
        </el-page-header>
        <div class="row">
          <div class="col-sm-5 p-t-10">
            <div class="form-group">
              <label class="col-md-4 control-label">型号</label>
              <div class="col-md-8">
                <el-input
                  v-model="model.model_number"
                  size="small"
                  placeholder="型号"
                ></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">序列号</label>
              <div class="col-md-8">
                <el-input
                  v-model="model.serial_number"
                  size="small"
                  placeholder="序列号"
                ></el-input>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">零件号</label>
              <div class="col-md-8">
                <el-input
                  v-model="model.component_number"
                  size="small"
                  placeholder="零件号"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <el-button type="primary" @click="handlePost">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { drillNew, drillUpdate, drillDetail } from '@/service/getData'
export default {
  data() {
    return {
      model: {
        model_number: '',
        serial_number: '',
        component_number: '',
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getModel(this.$route.params.id)
    }
  },
  methods: {
    async handlePost() {
      if (!this.model.serial_number) {
        this.$alert('序列号不能为空')
        return
      }
      if (this.model.id) {
        let res = await drillUpdate(this.model)
        if (res.code == 0) {
          this.$router.go(-1)
        }
      } else {
        let res = await drillNew(this.model)
        if (res.code == 0) {
          this.$router.go(-1)
        }
      }
    },

    async getModel(id) {
      let res = await drillDetail(id)
      this.model = res.data
    },
  },
}
</script>